export default __webpack_public_path__ + "static/media/early.448b2178.png";